"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddSubjectsToReviewCycleResponse () {
        return AddSubjectsToReviewCycleResponse;
    },
    get CreateReviewCycleResponse () {
        return CreateReviewCycleResponse;
    },
    get GetReviewCyclePreviewSubjectsResultsResponse () {
        return GetReviewCyclePreviewSubjectsResultsResponse;
    },
    get GetReviewCyclesResponse () {
        return GetReviewCyclesResponse;
    },
    get PostReviewCyclePreviewSubjectsResponse () {
        return PostReviewCyclePreviewSubjectsResponse;
    },
    get ReviewCyclePreviewSubject () {
        return ReviewCyclePreviewSubject;
    },
    get UpdateReviewCycleResponse () {
        return UpdateReviewCycleResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewcycle = require("./review-cycle");
const GetReviewCyclesResponse = _zod.z.object({
    data: _zod.z.array(_reviewcycle.ReviewCycle),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        pagination: _zod.z.object({
            skip: _zod.z.number(),
            limit: _zod.z.number(),
            total: _zod.z.number()
        })
    })
});
const UpdateReviewCycleResponse = _zod.z.object({
    data: _zod.z.object({
        cycleId: _utilsisomorphic.transformObjectId,
        taskId: _utilsisomorphic.transformObjectId.optional()
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const CreateReviewCycleResponse = _zod.z.object({
    data: _zod.z.object({
        cycleId: _utilsisomorphic.transformObjectId,
        taskId: _utilsisomorphic.transformObjectId
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const AddSubjectsToReviewCycleResponse = _zod.z.object({
    data: _zod.z.object({
        cycleId: _utilsisomorphic.transformObjectId,
        taskId: _utilsisomorphic.transformObjectId
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const PostReviewCyclePreviewSubjectsResponse = _zod.z.object({
    data: _zod.z.object({
        previewId: _utilsisomorphic.transformObjectId,
        total: _zod.z.number()
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const ReviewCyclePreviewSubject = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    managerId: _utilsisomorphic.transformObjectId.optional(),
    managerName: _zod.z.string().optional(),
    groupName: _zod.z.string().optional(),
    hireDate: _utilsisomorphic.transformDate.optional()
});
const GetReviewCyclePreviewSubjectsResultsResponse = _zod.z.object({
    data: _zod.z.array(ReviewCyclePreviewSubject),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        pagination: _zod.z.object({
            skip: _zod.z.number(),
            limit: _zod.z.number(),
            total: _zod.z.number()
        })
    })
});
